import React, { useState } from 'react';
import { Lock, Crown } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import SubscriptionPlans from '../SubscriptionPlans';

const COPY = {
  area_locked: {
    title: 'Disponible en plan Profesional',
    body: 'Esta área del derecho no está incluida en tu perfil gratuito. Con Premium (mensual o anual) consultas a los 22 socios especialistas, en los 6 países y sin límite mensual.',
  },
  limit_reached: {
    title: 'Llegaste a tus 5 consultas gratuitas del mes',
    body: 'Tu cupo se renueva el primer día del próximo mes. Con Premium (mensual o anual) tienes consultas ilimitadas y acceso a todas las áreas.',
  },
};

export const UpgradeDialog = ({ reason, onClose }) => {
  const [showPlans, setShowPlans] = useState(false);
  const c = COPY[reason] || COPY.area_locked;
  if (showPlans) return <SubscriptionPlans onClose={() => { setShowPlans(false); onClose(); }} />;
  return (
    <Dialog open={!!reason} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="upgrade-dialog" className="border-slate-700 bg-slate-900 text-white">
        <DialogHeader>
          <div className="mb-2 flex h-11 w-11 items-center justify-center rounded-xl bg-amber-500/15"><Lock className="h-5 w-5 text-amber-400" /></div>
          <DialogTitle data-testid="upgrade-dialog-title" className="font-['Outfit']">{c.title}</DialogTitle>
          <DialogDescription className="text-slate-400">{c.body}</DialogDescription>
        </DialogHeader>
        <div className="mt-2 flex flex-col gap-2 sm:flex-row sm:justify-end">
          <button data-testid="upgrade-dialog-close" onClick={onClose} className="rounded-full border border-slate-700 px-5 py-2 text-sm text-slate-300 hover:bg-slate-800 transition-colors">Ahora no</button>
          <button data-testid="upgrade-plan-btn" onClick={() => setShowPlans(true)} className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-500 px-5 py-2 text-sm font-semibold text-slate-950 hover:bg-amber-400 transition-colors">
            <Crown className="h-4 w-4" /> Mejorar mi plan
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
